export default __webpack_public_path__ + "static/ImageCard-90c881250f4dfe0b0cc6297114c31def.png";